/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  FormFieldType,
  IFormTime,
  IFormValidatable,
  RequiredValidations,
} from '../typings';
import { BaseFormFieldBuilder } from '.';

type Validations = RequiredValidations<IFormTime['validations']>;

export class TimeFormFieldBuilder
  extends BaseFormFieldBuilder<IFormTime>
  implements IFormValidatable<Validations>
{
  // @ts-ignore
  private _type = FormFieldType.Time as const;
  protected declare _value?: IFormTime['value'];
  private _validations?: Validations;

  constructor() {
    super();
  }

  public validation(value: Validations[number]): this {
    if (this._validations) {
      this._validations.push(value);
    } else {
      this._validations = [value];
    }

    return this;
  }

  public validations(value: Validations): this {
    if (this._validations) {
      this._validations.push(...value);
    } else {
      this._validations = [...value];
    }

    return this;
  }
}
